export { TestimonialsPageQuotes } from "./TestimonialsPageQuotes"
